import { useState } from "react";

// Small helper for the collapsible "card" sections in the System Admin VCA Data
// tab (Sync Anomalies / Skipped Contacts / Pipeline) so the long stacked panels
// can be folded to cut scrolling.  Returns { open, toggle, chevron, headerProps }.
//  - spread headerProps onto the section-header div (adds pointer cursor + toggle)
//  - render {chevron} at the start of the section-title
//  - gate the body and header-right controls behind {open && ...}
//  - controls inside the header that should NOT toggle collapse must call
//    stopPropagation (e.g. wrap them in a div with onClick stopPropagation)
export default function useCollapse(defaultOpen = true) {
  const [open, setOpen] = useState(defaultOpen);
  const toggle = () => setOpen((o) => !o);
  const chevron = (
    <span
      aria-hidden
      style={{
        display: "inline-block",
        transition: "transform .15s",
        transform: open ? "rotate(90deg)" : "rotate(0deg)",
        color: "var(--text3)",
        fontSize: 11,
      }}
    >
      ▶
    </span>
  );
  const headerProps = { onClick: toggle, style: { cursor: "pointer" } };
  return { open, toggle, chevron, headerProps };
}
